import { render, staticRenderFns } from "./DashboardWidgetCardWings.vue?vue&type=template&id=69949cfb&"
import script from "./DashboardWidgetCardWings.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetCardWings.vue?vue&type=script&lang=js&"
import style0 from "./DashboardWidgetCardWings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports